import React, {Fragment} from 'react';
import {translate} from "react-i18next";
import CompanyApi from "../../apis/CompanyApi";
import {connect} from "react-redux";
import {companiesUpdated} from "../../actions/companyAction";

class EditCompany extends React.Component {

    defaultState = {
        loading: false,
        isOpen: false,
        errors: {},
        id: null,
        name: '',
        shortName: '',
        street: '',
        streetNumber: '',
        zipcode: '',
        city: '',
        mail: '',
        phone: '',
        taxNumber: '',
        contactPerson: ''
    };

    state = this.defaultState;

    cancel = () => {
        this.setState(this.defaultState);
    };

    open = () => {
        const { company } = this.props;
        this.setState({
            isOpen: true,
            id: company.id,
            name: company.name,
            shortName: company.shortName,
            street: company.address.street,
            streetNumber: company.address.streetNumber,
            zipcode: company.address.zipcode,
            city: company.address.city,
            mail: company.mail,
            phone: company.phone,
            taxNumber: company.taxNumber,
            contactPerson: company.contactPerson
        })
    };

    handleSubmit = (e) => {
        e.preventDefault();
        this.setState({loading: true, errors: {}});
        CompanyApi.updateCompany(this.state.id, this.state.name, this.state.shortName, this.state.street, this.state.streetNumber, this.state.zipcode, this.state.city, this.state.mail, this.state.phone, this.state.taxNumber, this.state.contactPerson)
            .then((response) => {
                if (response.status === 200) {
                    this.setState({loading: false});
                    if (response.data.success === true) {
                        this.cancel();
                        this.props.companiesUpdated();
                        this.props.onSuccess();
                    } else {
                        this.setState({errors: response.data.errors});
                    }
                }
            })
    };

    render() {
        const {t} = this.props;
        return (
            <Fragment>
                <a onClick={this.open}>
                    <i className="fa fa-pencil"/>
                </a>
                {this.state.isOpen ? (
                    <div className="AddCompanyDialog modal inmodal in text-left" tabIndex="-1" role="dialog"
                         style={{display: 'block'}}>
                        <div className="modal-dialog">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <button className="close" onClick={this.cancel}>
                                        <span>x</span>
                                    </button>
                                    <h4 className="modal-title">
                                        {t('companies.edit.dialog.title')}
                                    </h4>
                                </div>
                                <form onSubmit={this.handleSubmit}>
                                    <div className="modal-body">
                                        <div className="row">
                                            <div className="col-md-8">
                                                <div
                                                    className={"form-group" + ((this.state.errors && this.state.errors.name) ? ' has-error' : '')}>
                                                    <label>{t('companies.add.dialog.name.label')}</label>
                                                    <input className="form-control" type="text" name="name"
                                                           value={this.state.name}
                                                           onChange={(e) => this.setState({name: e.target.value})}/>
                                                    {(this.state.errors && this.state.errors.name) ? (
                                                        <span className="help-block">
                                                            {t('companies.add.dialog.name.error.' + this.state.errors.name)}
                                                        </span>
                                                    ) : null}
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div
                                                    className={"form-group" + ((this.state.errors && this.state.errors.shortName) ? ' has-error' : '')}>
                                                    <label>{t('companies.add.dialog.shortName.label')}</label>
                                                    <input className="form-control" type="text" name="shortName"
                                                           value={this.state.shortName}
                                                           onChange={(e) => this.setState({shortName: e.target.value})}/>
                                                    {(this.state.errors && this.state.errors.shortName) ? (
                                                        <span className="help-block">
                                                            {t('companies.add.dialog.shortName.error.' + this.state.errors.shortName)}
                                                        </span>
                                                    ) : null}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="hr-line-dashed"/>
                                        <div className="row">
                                            <div className="col-md-8">
                                                <div
                                                    className={"form-group" + ((this.state.errors && this.state.errors.street) ? ' has-error' : '')}>
                                                    <label>{t('companies.add.dialog.street.label')}</label>
                                                    <input className="form-control" type="text" name="street"
                                                           value={this.state.street}
                                                           onChange={(e) => this.setState({street: e.target.value})}/>
                                                    {(this.state.errors && this.state.errors.street) ? (
                                                        <span className="help-block">
                                                            {t('companies.add.dialog.street.error.' + this.state.errors.street)}
                                                        </span>
                                                    ) : null}
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div
                                                    className={"form-group" + ((this.state.errors && this.state.errors.streetNumber) ? ' has-error' : '')}>
                                                    <label>{t('companies.add.dialog.streetNumber.label')}</label>
                                                    <input className="form-control" type="text" name="streetNumber"
                                                           value={this.state.streetNumber}
                                                           onChange={(e) => this.setState({streetNumber: e.target.value})}/>
                                                    {(this.state.errors && this.state.errors.streetNumber) ? (
                                                        <span className="help-block">
                                                            {t('companies.add.dialog.streetNumber.error.' + this.state.errors.streetNumber)}
                                                        </span>
                                                    ) : null}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-4">
                                                <div
                                                    className={"form-group" + ((this.state.errors && this.state.errors.zipcode) ? ' has-error' : '')}>
                                                    <label>{t('companies.add.dialog.zipcode.label')}</label>
                                                    <input className="form-control" type="text" name="zipcode"
                                                           value={this.state.zipcode}
                                                           onChange={(e) => this.setState({zipcode: e.target.value})}/>
                                                    {(this.state.errors && this.state.errors.zipcode) ? (
                                                        <span className="help-block">
                                                            {t('companies.add.dialog.zipcode.error.' + this.state.errors.zipcode)}
                                                        </span>
                                                    ) : null}
                                                </div>
                                            </div>
                                            <div className="col-md-8">
                                                <div
                                                    className={"form-group" + ((this.state.errors && this.state.errors.city) ? ' has-error' : '')}>
                                                    <label>{t('companies.add.dialog.city.label')}</label>
                                                    <input className="form-control" type="text" name="city"
                                                           value={this.state.city}
                                                           onChange={(e) => this.setState({city: e.target.value})}/>
                                                    {(this.state.errors && this.state.errors.city) ? (
                                                        <span className="help-block">
                                                            {t('companies.add.dialog.city.error.' + this.state.errors.city)}
                                                        </span>
                                                    ) : null}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="hr-line-dashed"/>
                                        <div className="row">
                                            <div className="col-md-6">
                                                <div
                                                    className={"form-group" + ((this.state.errors && this.state.errors.mail) ? ' has-error' : '')}>
                                                    <label>{t('companies.add.dialog.mail.label')}</label>
                                                    <input className="form-control" type="text" name="mail"
                                                           value={this.state.mail}
                                                           onChange={(e) => this.setState({mail: e.target.value})}/>
                                                    {(this.state.errors && this.state.errors.mail) ? (
                                                        <span className="help-block">
                                                            {t('companies.add.dialog.mail.error.' + this.state.errors.mail)}
                                                        </span>
                                                    ) : null}
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div
                                                    className={"form-group" + ((this.state.errors && this.state.errors.phone) ? ' has-error' : '')}>
                                                    <label>{t('companies.add.dialog.phone.label')}</label>
                                                    <input className="form-control" type="text" name="phone"
                                                           value={this.state.phone}
                                                           onChange={(e) => this.setState({phone: e.target.value})}/>
                                                    {(this.state.errors && this.state.errors.phone) ? (
                                                        <span className="help-block">
                                                            {t('companies.add.dialog.phone.error.' + this.state.errors.phone)}
                                                        </span>
                                                    ) : null}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-6">
                                                <div
                                                    className={"form-group" + ((this.state.errors && this.state.errors.taxNumber) ? ' has-error' : '')}>
                                                    <label>{t('companies.add.dialog.taxNumber.label')}</label>
                                                    <input className="form-control" type="text" name="taxNumber"
                                                           value={this.state.taxNumber}
                                                           onChange={(e) => this.setState({taxNumber: e.target.value})}/>
                                                    {(this.state.errors && this.state.errors.taxNumber) ? (
                                                        <span className="help-block">
                                                            {t('companies.add.dialog.mail.error.' + this.state.errors.taxNumber)}
                                                        </span>
                                                    ) : null}
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div
                                                    className={"form-group" + ((this.state.errors && this.state.errors.contactPerson) ? ' has-error' : '')}>
                                                    <label>{t('companies.add.dialog.contactPerson.label')}</label>
                                                    <input className="form-control" type="text" name="contactPerson"
                                                           value={this.state.contactPerson}
                                                           onChange={(e) => this.setState({contactPerson: e.target.value})}/>
                                                    {(this.state.errors && this.state.errors.contactPerson) ? (
                                                        <span className="help-block">
                                                            {t('companies.add.dialog.contactPerson.error.' + this.state.errors.contactPerson)}
                                                        </span>
                                                    ) : null}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="modal-footer">
                                        <button className="btn btn-default" type="button" onClick={this.cancel}>
                                            {t('default.cancel')}
                                        </button>
                                        <button className="btn btn-primary" type="submit" disabled={this.state.loading}>
                                            {this.state.loading ? (
                                                <i className='fa fa-spinner fa-spin inline-block m-r'/>
                                            ) : null}
                                            {t('default.save')}
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                ) : null}
            </Fragment>
        )
    }
}

export default connect(null, {companiesUpdated})(translate()(EditCompany));
